import React from "react";
import { ENV } from "config/config";
import {
  Button,
  Form,
  Container,
  Row,
  Modal,
  FormGroup,
} from "react-bootstrap";
const { formatUrl, formatUrlManual, formatMetaKeywords, integerNumberValidator } = ENV;

const CategoryModal = ({
  modalCloseHandler,
  setCategory,
  modalType,
  selectCategories,
  openModal,
  category,
  submit,
  categoryErrors,
  setCategoryErrors,
  fetchGallery,
  imageView,
  setSelectedImageType,
  selectedImageType,
}) => {
  return (
    <Container fluid>
      {modalType > 0 && (
        <Modal
          className="modal-primary edit-cotnact-modal"
          onHide={modalCloseHandler}
          show={openModal}
        >
          <Modal.Header className="justify-content-center">
            <Row>
              <div className="col-12">
                <h4 className="mb-0 mb-md-3 mt-0">
                  {modalType === 1
                    ? "View"
                    : modalType === 2
                    ? "Add"
                    : modalType === 3
                    ? "Edit"
                    : ""}{" "}
                  Category
                </h4>
              </div>
            </Row>
          </Modal.Header>
          <Modal.Body>
            <Form className="text-left">
              <Form.Group>
                <label>
                  Name <span className="text-danger">*</span>
                </label>
                <Form.Control
                  className={categoryErrors.name ? `on-error` : ``}
                  placeholder="Enter name"
                  disabled={modalType === 1}
                  type="text"
                  name="name"
                  onChange={(e) => {
                    const newName = e.target.value;
                    const newUrl = formatUrl(newName);
                    if (category.isExternal) {
                      setCategory({
                        ...category,
                        name: newName,
                        metaTitle: newName,
                        metaKeyword: formatMetaKeywords(newUrl),
                      });
                    } else {
                      setCategory({
                        ...category,
                        name: newName,
                        url: newUrl,
                        metaTitle: newName,
                        metaKeyword: formatMetaKeywords(newUrl),
                      });
                    }
                    setCategoryErrors((prevErrors) => ({
                      ...prevErrors,
                      name: "",
                    }));
                  }}
                  value={category?.name}
                  required
                />
                <span className={categoryErrors.name !== "" ? `` : `d-none`}>
                  <label className="pl-1 text-danger">
                    {categoryErrors.name}
                  </label>
                </span>
              </Form.Group>
              <Form.Group>
                <label className="">External Url</label>
                <div className="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="isExternal"
                    disabled={modalType === 1}
                    onChange={(e) =>
                      setCategory({
                        ...category,
                        isExternal: !category.isExternal,
                      })
                    }
                    checked={category?.isExternal}
                  />
                  <span className="checkmark"></span>
                </div>
              </Form.Group>
              <Form.Group>
                <label className="">
                  URL<span className="text-danger">*</span>
                </label>
                <Form.Control
                  className={categoryErrors.url ? `on-error` : ``}
                  placeholder="Enter url"
                  disabled={modalType === 1}
                  type="text"
                  name="url"
                  onChange={(e) => {
                    if (category.isExternal) {
                      setCategory({
                        ...category,
                        url: e.target.value,
                      });
                    } else {
                      setCategory({
                        ...category,
                        url: formatUrlManual(e.target.value),
                      });
                    }
                    setCategoryErrors((prevErrors) => ({
                      ...prevErrors,
                      url: "",
                    }));
                  }}
                  value={category?.url}
                  required
                />
                <span className={categoryErrors.url !== "" ? `` : `d-none`}>
                  <label className="pl-1 text-danger">
                    {categoryErrors.url}
                  </label>
                </span>
              </Form.Group>

              <Form.Group>
                <label className="">
                  Parent Category<span className="text-danger">*</span>
                </label>

                <Form.Control
                  className={categoryErrors.parentId ? `on-error` : ``}
                  as="select"
                  onChange={(e) => {
                    const value = e.target.value;
                    setCategory({ ...category, parentId: value === "" ? null : value });
                    setCategoryErrors((prevErrors) => ({
                      ...prevErrors,
                      parentId: "",
                    }));
                  }}
                  value={category?.parentId || ""}
                  placeholder="Select parent category"
                  disabled={modalType === 1}
                  required
                >
                  <option value="-">Select parent category</option>
                  <option value="0">I am parent</option>
                  {selectCategories &&
                    selectCategories.map((option, index) => (
                      <option key={index} value={option.id}>
                        {option.name}
                      </option>
                    ))}
                </Form.Control>
                <span
                  className={categoryErrors.parentId !== "" ? `` : `d-none`}
                >
                  <label className="pl-1 text-danger">
                    {categoryErrors.parentId}
                  </label>
                </span>
              </Form.Group>

              <Form.Group>
                <label className="">
                  Image<span className="text-danger">*</span>
                </label>
                <div className="d-flex align-items-center">
                  <Button
                    className="btn-filled mt-3"
                    variant="info"
                    onClick={fetchGallery}
                  >
                    Choose Image
                  </Button>
                  <Form.Control
                    as="select"
                    className="image-select"
                    value={selectedImageType}
                    onChange={(e) => setSelectedImageType(e.target.value)}
                  >
                    <option value="default">Default</option>
                    <option value="related">Related</option>
                    <option value="search">Search</option>
                  </Form.Control>
                </div>
              </Form.Group>
              <span className={categoryErrors.image !== "" ? `` : `d-none`}>
                <label className="pl-1 text-danger">
                  {categoryErrors.image}
                </label>
              </span>

              {imageView &&
                Object.entries(imageView || {}).map(([type, image]) => (
                  <Form.Group key={type}>
                    <label className="">
                      {type.charAt(0).toUpperCase() + type.slice(1)}:
                    </label>
                    {image ? (
                      <img
                        src={`${ENV.assetsUrl}gallery/${image}`}
                        id={`imageUploader-${type}`}
                        className="image-fluid"
                        style={{ width: "30%", height: "30%" }}
                        alt={`${type}-gallery-image`}
                      />
                    ) : (
                      <span className=""> No image selected</span>
                    )}
                  </Form.Group>
                ))}

              <Form.Group>
                <label className="">
                  Sort Order<span className="text-danger">*</span>
                </label>
                <Form.Control
                  className={categoryErrors.sortOrder ? `on-error` : ``}
                  placeholder="Enter number"
                  disabled={modalType === 1}
                  type="text"
                  name="sortOrder"
                  onKeyDown={(e) => integerNumberValidator(e)}
                  onChange={(e) => {
                    setCategory({ ...category, sortOrder: e.target.value });
                    setCategoryErrors((prevErrors) => ({
                      ...prevErrors,
                      sortOrder: "",
                    }));
                  }}
                  value={category?.sortOrder}
                  required
                />
                <span
                  className={categoryErrors.sortOrder !== "" ? `` : `d-none`}
                >
                  <label className="pl-1 text-danger">
                    {categoryErrors.sortOrder}
                  </label>
                </span>
              </Form.Group>

              <Form.Group>
                <label className="">
                  Color<span className="text-danger">*</span>
                </label>
                <div>
                  <input
                    type="color"
                    className={categoryErrors.color ? "on-error" : ""}
                    name="color"
                    defaultValue="#0093b1"
                    value={category.color}
                    onChange={(e) => {
                      setCategory({
                        ...category,
                        color: e.target.value,
                      });
                      setCategoryErrors((prevErrors) => ({
                        ...prevErrors,
                        color: "",
                      }));
                    }}
                    required
                  />
                </div>
                <span className={categoryErrors.color !== "" ? "" : "d-none"}>
                  <label className="pl-1 text-danger">
                    {categoryErrors.color}
                  </label>
                </span>
              </Form.Group>
              <Form.Group>
                <label className="">Meta Title</label>
                <Form.Control
                  placeholder="Enter Meta tiltes"
                  disabled={modalType === 1}
                  type="text"
                  name="metaTitle"
                  onChange={(e) =>
                    setCategory({ ...category, metaTitle: e.target.value })
                  }
                  value={category?.metaTitle}
                />
              </Form.Group>
              <Form.Group>
                <label className="">Meta Keywords</label>
                <Form.Control
                  placeholder="Enter Meta Keywords"
                  disabled={modalType === 1}
                  type="text"
                  name="metaKeyword"
                  onChange={(e) =>
                    setCategory({ ...category, metaKeyword: e.target.value })
                  }
                  value={category?.metaKeyword}
                />
              </Form.Group>
              <Form.Group>
                <label className="">Meta Description</label>
                <Form.Control
                  placeholder="Enter Meta Description"
                  disabled={modalType === 1}
                  type="text"
                  name="metaDescription"
                  onChange={(e) =>
                    setCategory({
                      ...category,
                      metaDescription: e.target.value,
                    })
                  }
                  value={category?.metaDescription}
                />
              </Form.Group>
              <Form.Group>
                <label className="">Show in Top Menu</label>
                <div className="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="isShowInTopMenu"
                    disabled={modalType === 1}
                    onChange={(e) =>
                      setCategory({
                        ...category,
                        isShowInTopMenu: !category.isShowInTopMenu,
                      })
                    }
                    checked={category?.isShowInTopMenu}
                  />
                  <span className="checkmark"></span>
                </div>
              </Form.Group>
              <Form.Group>
                <label className="">Show in Header</label>
                <div className="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="showInHeader"
                    disabled={modalType === 1}
                    onChange={(e) =>
                      setCategory({
                        ...category,
                        isShowInHeader: !category.isShowInHeader,
                      })
                    }
                    checked={category?.isShowInHeader}
                  />
                  <span className="checkmark"></span>
                </div>
              </Form.Group>
              <Form.Group>
                <label className="">Show in Footer</label>

                <div className="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="isShowInFooter"
                    disabled={modalType === 1}
                    onChange={(e) =>
                      setCategory({
                        ...category,
                        isShowInFooter: !category.isShowInFooter,
                      })
                    }
                    checked={category?.isShowInFooter}
                  />
                  <span className="checkmark"></span>
                </div>
              </Form.Group>
              <FormGroup>
                <label className="">Status</label>
                <div className="d-flex align-items-center">
                  <label className="right-label-radio mr-3 mb-2">
                    Active
                    <input
                      name="isActive"
                      disabled={modalType === 1}
                      type="radio"
                      checked={category?.isActive}
                      value={category?.isActive}
                      onChange={(e) =>
                        setCategory({ ...category, isActive: true })
                      }
                    />
                    <span className="checkmark"></span>
                  </label>
                  <label className="right-label-radio mr-3 mb-2">
                    Inactive
                    <input
                      name="isActive"
                      disabled={modalType === 1}
                      type="radio"
                      checked={!category?.isActive}
                      value={!category?.isActive}
                      onChange={(e) =>
                        setCategory({ ...category, isActive: false })
                      }
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
              </FormGroup>
            </Form>
          </Modal.Body>

          <Modal.Footer>
            <Button className="outline-button" onClick={modalCloseHandler}>
              Close
            </Button>
            {modalType === 2 || modalType === 3 ? (
              <Button className="btn-filled" onClick={submit}>
                Submit
              </Button>
            ) : (
              ""
            )}
          </Modal.Footer>
        </Modal>
      )}
    </Container>
  );
};

export default CategoryModal;
